import Axios from 'axios'
import { Cookies } from 'react-cookie'
import { ServicePath } from '../utils';
var CryptoJS = require("crypto-js");

export const Request = (method, path, data) => {
    const cookies = new Cookies()
    const token = cookies.get('token')
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
    }

    return new Promise( (resolve, reject) => {
        Axios({
            method: method,
            url: `${process.env.REACT_APP_API_URL}${path}`,
            headers: headers,
            data: data
        }).then(function (response) {
            if(response.status === 200){
                resolve(response.data)
            }else{
                return reject(Error(response.data.msg))
            }
        }).catch(function (error) {
            reject(error)
        })
    })
    // return Axios({
    //     method: method,
    //     url: `${process.env.REACT_APP_API_URL}${path}`,
    //     headers: headers,
    //     data: data
    // }).then(response => {
    //     return response
    // }).catch(err => {
    //     return err
    // })
}

export const AuthRequest = (method, path, data) => {
    const cookies = new Cookies()
    const token = cookies.get('user')
    var tokentext = ''
    // Decrypt
    if (token !== null && token !== undefined) {
        var bytes = CryptoJS.AES.decrypt(token, process.env.REACT_APP_HASH_KEY);
        tokentext = bytes.toString(CryptoJS.enc.Utf8);
    }  
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + (tokentext === '' ? '' : JSON.parse(tokentext))
    }

    return new Promise((resolve, reject) => {
        Axios({
            method: method,
            url: `${process.env.REACT_APP_AUTH_API_URL}${path}`,
            headers: headers,
            data: data
        }).then(function (response) {
            if (response.status === 200) {
                resolve(response.data)
            }else if(response.status === 401){

            }
            else {
                return reject(Error(response.data.msg))
            }
        }).catch(function (error) {
            reject(error)
        })
    })
}

export const getUser =()=>{
    return AuthRequest('GET', ServicePath.GetUser, {}).then( res=>{
        return res
    }).catch(err=>{
        console.log(err)
        return err
    })
}
// export const authSign =()=>{
//     const data = {
//         "work":"AUTH_SIGN",
//         "app_key": "ElbGQNRz20Sgqf0RkHoo1A8htVTZh6shrIwDlbYz8HqJ5fYJLavPagRNaIkkASR6vnoQBQd42M6x3okp"
//     }
//     return requestNoti(data).then( res=>{
//         return res
//     }).catch(err=>{
//         return err
//     })
// }